import React, { useRef, useState } from "react";
import "./Contact.css";

import emailjs from "@emailjs/browser";

import { BiRightArrowAlt, BiMailSend } from "react-icons/bi";
import { SiWechat } from "react-icons/si";
import { FaTelegramPlane } from "react-icons/fa";
import { BsWhatsapp } from "react-icons/bs";

const Contact = () => {
  const form = useRef();
  const [copied, setCopied] = useState(false);
  const [status, setStatus] = useState("idle");

  const handleCopy = () => {
    navigator.clipboard.writeText("ton_4080");
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  const sendEmail = (e) => {
    e.preventDefault();

    setStatus("sending");

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(
        (result) => {
          // 2. SUCESSO
          console.log(result.text);
          setStatus("success"); // Altera para sucesso
          e.target.reset(); // Limpa o formulário

          // Opcional: Volta para 'idle' depois de 5 segundos
          setTimeout(() => setStatus("idle"), 5000);
        },
        (error) => {
          // 3. ERRO
          console.log(error.text);
          setStatus("error"); // Altera para erro

          // Opcional: Volta para 'idle' depois de 5 segundos
          setTimeout(() => setStatus("idle"), 5000);
        }
      );

    e.target.reset();
  };

  return (
    <section className="contact section" id="contact">
      <h2 className="section__title">Get in touch</h2>
      <span className="section__subtitle">Contact Me</span>

      <div className="contact__container container grid">
        <div className="contact__content">
          <h3 className="contact__title">Talk to me</h3>

          <div className="contact__info">
            <div className="contact__card">
              <BiMailSend className="contact__card-icon" />

              <h3 className="contact__card-title">Email</h3>
              <span className="contact__card-data">
                ewertonlopespereira@gmail.com
              </span>

              <a
                href="mailto:ewertonlopespereira@gmail.com"
                className="contact__button"
              >
                Write me
                <BiRightArrowAlt className="contact__button-icon" />
              </a>
            </div>
            <div className="contact__card">
              <BsWhatsapp className="contact__card-icon" />

              <h3 className="contact__card-title">Whatsapp</h3>
              <span className="contact__card-data">+55 11 973291913</span>

              <a
                href="https://api.whatsapp.com/send?phone=62214408789&text=Hello, more information!"
                className="contact__button"
                target="_blank"
                rel="noreferrer"
              >
                Write me
                <BiRightArrowAlt className="contact__button-icon" />
              </a>
            </div>
            <div className="contact__card">
              <SiWechat className="contact__card-icon" />

              <h3 className="contact__card-title">WeChat</h3>
              <span className="contact__card-data">ton_4080</span>

              <button className="contact__button" onClick={handleCopy}>
                {copied ? "ID copied!" : "Copy ID"}
                <BiRightArrowAlt className="contact__button-icon" />
              </button>
            </div>
          </div>
        </div>

        <div className="contact__content">
          <h3 className="contact__title">Write me your project</h3>

          <form ref={form} onSubmit={sendEmail} className="contact__form">
            <div className="contact__form-div">
              <label className="contact__form-tag">Name</label>
              <input
                type="text"
                name="name"
                className="contact__form-input"
                placeholder="Insert your name"
              />
            </div>
            <div className="contact__form-div">
              <label className="contact__form-tag">Email</label>
              <input
                type="email"
                name="email"
                className="contact__form-input"
                placeholder="Insert your email"
              />
            </div>
            <div className="contact__form-div contact__form-area">
              <label className="contact__form-tag">Project</label>
              <textarea
                name="project"
                cols="30"
                rows="10"
                placeholder="Tell me about your project"
                className="contact__form-input"
              ></textarea>
            </div>
            <button
              href="#contact"
              className="button"
              disabled={status === "sending"}
            >
              {status === "sending" ? "wait..." : "Send Message"}
              <FaTelegramPlane className="button__icon" />
            </button>
          </form>
          
          <div style={{ marginTop: '10px', marginBottom: '20px' }}>
          {status === "sending" && (
            <p style={{ backgroundColor: 'gray',color: "white", textAlign: "center", borderRadius: '8px', padding: '1rem' }}>
              Sending Message...
            </p>
          )}
          {status === "success" && (
           <p style={{ backgroundColor: 'green',color: "white", textAlign: "center", borderRadius: '8px', padding: '1rem' }}>
             Message sent successfully! Thank you.
            </p>
          )}
          {status === "error" && (
            <p style={{ backgroundColor: 'red',color: "white", textAlign: "center", borderRadius: '8px', padding: '1rem' }}>
              Error sending the message. Please try again.
            </p>
          )}
         
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
